import store from '@/store'
export default [
  {
    path: '/info-inquiries',
    name: 'info-inquiry',
    meta: { requiresAuth: true },
    component: () => import('@/pages/info-inquiry/index.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('infoInquiry/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/info-inquiries/create',
    name: 'info-inquiry-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/info-inquiry/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('infoInquiry/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/info-inquiries/:id',
    name: 'info-inquiry-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/info-inquiry/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('infoInquiry/dataBeforeCreate')
      await store.dispatch('infoInquiry/find', to.params.id)
      next()
    }
  }
]
